import { render, staticRenderFns } from "./Personalreport.vue?vue&type=template&id=6e611b2d&scoped=true&"
import script from "./Personalreport.vue?vue&type=script&lang=js&"
export * from "./Personalreport.vue?vue&type=script&lang=js&"
import style0 from "./Personalreport.vue?vue&type=style&index=0&id=6e611b2d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e611b2d",
  null
  
)

export default component.exports